import React from "react";
import { Badge } from "@mantine/core";
import EmployeeImportStatusBadgeStyles from "../assets/EmployeeImportStatusBadgeStyles";

type EmployeeImportStatusBadgeProps = {
  status: string;
};

const EmployeeImportStatusBadge: React.FC<EmployeeImportStatusBadgeProps> = ({
  status,
}) => {
  const { classes, cx } = EmployeeImportStatusBadgeStyles();

  switch (status) {
    case "importing":
      return (
        <Badge size="sm" className={cx(classes.label, classes.importing)}>
          {status}
        </Badge>
      );
    case "uploaded":
      return (
        <Badge size="sm" className={cx(classes.label, classes.uploaded)}>
          {status}
        </Badge>
      );
    case "imported":
      return (
        <Badge size="sm" className={cx(classes.label, classes.imported)}>
          {status}
        </Badge>
      );
    case "processed":
      return (
        <Badge size="sm" className={cx(classes.label, classes.processed)}>
          {status}
        </Badge>
      );
    case "cancelled":
      return (
        <Badge
          size="sm"
          color="red"
          className={cx(classes.label, classes.cancelled)}
        >
          {status}
        </Badge>
      );
    default:
      return <Badge className={classes.label}>{status}</Badge>;
  }
};

export default EmployeeImportStatusBadge;
